// mapping language code
export const mapLanguage = (code: string) => {
    let langCode = "";
    switch (code) {
        case "zh-Hans":
            langCode = "zh-CN";
            break;
        case "en":
            langCode = "en-US";
            break;
        case "cs":
            langCode = "cs-CZ";
            break;
        case "pt":
            langCode = "pt-BR";
            break;
        case "ja":
            langCode = "ja-JP";
            break;
        case "es":
            langCode = "es-MX";
            break;
        default:
            langCode = `${code + "-" + code?.toUpperCase()}`;
            break;
    }
    return langCode;
};